import { Button } from '@instabox/consumer-web-ui'
import { useRouter } from 'next/router'
import { FC, useMemo } from 'react'

import useDisplayNames from '../../hooks/useDisplayNames'
import { localeToLanguageCode, localeToMarketCode } from '../../utils'
import styles from './switchLanguageButton.module.scss'

const SwitchLanguageButton: FC = () => {
  const { locale, locales, pathname, query, asPath, basePath, push } = useRouter()
  const currentLanguage = localeToLanguageCode(locale)
  const primaryLocale = useMemo(
    () =>
      locales
        .filter(l => l !== 'default' && localeToMarketCode(l) === localeToMarketCode(locale))
        .find(l => localeToLanguageCode(l) !== 'en'),
    [locales, locale],
  )
  const primaryLanguage = localeToLanguageCode(primaryLocale)
  const [languageNames] = useDisplayNames({ locale: primaryLocale, type: 'language' })

  const switchLanguage = () => {
    const newLanguage = currentLanguage === 'en' ? primaryLanguage : 'en'
    const newLocale = `${newLanguage}-${localeToMarketCode(locale).toUpperCase()}`
    push({ pathname: `${basePath}${pathname}`, query }, asPath, {
      locale: newLocale,
    })
  }

  return (
    <Button size="small" variant="ghost" onClick={switchLanguage} className={styles.button}>
      {currentLanguage === 'en' ? languageNames?.of(primaryLanguage) : 'English'}
    </Button>
  )
}

export default SwitchLanguageButton
